



















































import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import DatasetCard from '@/components/Dataset/DatasetCard.vue'
import Summary from '@/components/Summary/Summary.vue'
import { steps } from '@/data-dummy/simulation/steps'

export default Vue.extend({
  name: 'detail-modal',
  components: {
    DatasetCard,
    Summary
  },
  data: () => ({
    show: false
  }),
  computed: {
    ...mapGetters('results', {
      result: 'getResult'
    })
  },
  methods: {
    ...mapMutations('results', {
      UpdateResults: 'setResult'
    }),
    openDialog () {
      this.show = true
    }
  },
  mounted () {
    this.UpdateResults(steps[5])
  }
})
